import { roleConstants, alertConstants } from '../_constants'
import { roleService } from '../_services'
import { alertActions } from '../_actions'
export const roleActions = {
  
  getRoleList,
  clearAllMessages
  
}
function getRoleList() {
    return dispatch => {
      dispatch(request())
  
      roleService.getRoleList()
        .then(
          role => {
            console.log(role)
            dispatch(success(role))
          },
          error => {
            dispatch(failure(error.toString()))
            dispatch(alertActions.error(error.toString()))
          }
        )
    }
    function request(role) { return { type: roleConstants.GETALL_REQUEST, role } }
    function success(role) { return { type: roleConstants.GETALL_SUCCESS, role } }
    function failure(error) { return { type: roleConstants.GETALL_FAILURE, error } }
  }
  function clearAllMessages() {
    return dispatch => {
      dispatch(request())
    }
    function request() { return { type: alertConstants.CLEAR } }
  }